import { render, staticRenderFns } from "./Stats.vue?vue&type=template&id=54b4a940&scoped=true&"
import script from "./Stats.vue?vue&type=script&lang=ts&"
export * from "./Stats.vue?vue&type=script&lang=ts&"
import style0 from "./Stats.vue?vue&type=style&index=0&id=54b4a940&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54b4a940",
  null
  
)

export default component.exports